// Custom product descriptions, managed here (not in Shopify), per language.
// Keyed by Shopify product handle (slug). Leave a language empty to fall back
// to English, and if the whole entry is missing/empty it falls back to the
// Shopify description. Product names/prices/images/variants still come from Shopify.
export const PRODUCT_DESCRIPTIONS = {
  "late-night-hussla": {
    pl: `Late Night Hussla Black Glass Filter 12 mm | 35 mm
Late nights build legends.

Nie każdy zrozumie, czym jest Hussling.

To godziny, kiedy większość śpi, a Ty dalej robisz swoje. Kolejny projekt. Kolejny pomysł. Kolejny ruch. Muzyka gra w tle, miasto zwalnia, a głowa pracuje na pełnych obrotach.
Late Night Hussla powstał właśnie z tego klimatu.
Nie jest tylko szklanym filtrem. Jest częścią kultury husslerów – ludzi, którzy wiedzą, że lifestyle buduje się codziennie, a nie tylko wtedy, gdy ktoś patrzy.

Built Different.
W środku znajdziesz 9 spiralnie rozmieszczonych otworów, które wydłużają drogę dymu wewnątrz szkła. Dzięki temu dym ma więcej czasu na schłodzenie, a całość daje bardziej płynne i komfortowe doświadczenie.
To detal, którego nie widać na pierwszy rzut oka.
Ale właśnie z detali składa się Hussling.
Tak samo jak nie widać godzin spędzonych na budowaniu własnej drogi.

Made to Last.
Wykonany z wysokiej jakości Borosilicate Glass, odpornego na wysokie temperatury i codzienne użytkowanie.
Matowa czerń z logo SlimeGlass wygląda minimalistycznie, ale mówi wszystko.
Bez zbędnego flexu.
Bo prawdziwy styl nie musi krzyczeć.

Specyfikacja
Marka: SlimeGlass
Model: Late Night Hussla
Materiał: Borosilicate Glass
Kolor: Black
Długość: 35 mm
Średnica: 12 mm
Wnętrze: 9 spiralnych otworów chłodzących`,
    en: `Late Night Hussla Black Glass Filter 12 mm | 35 mm
Late nights build legends.

Not everyone will understand what Hussling is.

It's the hours when most people are asleep and you're still doing your thing. Another project. Another idea. Another move. Music playing in the background, the city slows down, and your mind runs at full speed.
Late Night Hussla was born from exactly that vibe.
It's not just a glass filter. It's part of the hussler culture – people who know that lifestyle is built every day, not only when someone's watching.

Built Different.
Inside you'll find 9 spiral-set holes that extend the smoke's path through the glass. This gives the smoke more time to cool, delivering a smoother, more comfortable experience.
It's a detail you don't notice at first glance.
But Hussling is made of details.
Just like the hours spent building your own path go unseen.

Made to Last.
Crafted from high-quality Borosilicate Glass, resistant to high temperatures and everyday use.
Matte black with the SlimeGlass logo looks minimal, but says everything.
No unnecessary flex.
Because real style doesn't have to shout.

Specification
Brand: SlimeGlass
Model: Late Night Hussla
Material: Borosilicate Glass
Colour: Black
Length: 35 mm
Diameter: 12 mm
Inside: 9 spiral cooling holes`,
    cs: `Late Night Hussla Black Glass Filter 12 mm | 35 mm
Late nights build legends.

Ne každý pochopí, co je Hussling.

Jsou to hodiny, kdy většina spí a ty dál děláš svoje. Další projekt. Další nápad. Další tah. Hudba hraje v pozadí, město zpomaluje a hlava jede na plný výkon.
Late Night Hussla vznikl přesně z téhle atmosféry.
Není to jen skleněný filtr. Je součástí kultury husslerů – lidí, kteří vědí, že lifestyle se buduje každý den, ne jen když se někdo dívá.

Built Different.
Uvnitř najdeš 9 spirálovitě rozmístěných otvorů, které prodlužují cestu kouře uvnitř skla. Kouř tak má víc času na zchlazení a celek nabízí plynulejší a příjemnější zážitek.
Je to detail, který na první pohled nevidíš.
Ale právě z detailů se Hussling skládá.
Stejně jako nejsou vidět hodiny strávené budováním vlastní cesty.

Made to Last.
Vyrobený z kvalitního borosilikátového skla, odolného vůči vysokým teplotám a každodennímu používání.
Matná čerň s logem SlimeGlass vypadá minimalisticky, ale řekne vše.
Bez zbytečného flexu.
Protože opravdový styl nemusí křičet.

Specifikace
Značka: SlimeGlass
Model: Late Night Hussla
Materiál: Borosilikátové sklo
Barva: Black
Délka: 35 mm
Průměr: 12 mm
Vnitřek: 9 spirálových chladicích otvorů`,
    de: `Late Night Hussla Black Glass Filter 12 mm | 35 mm
Late nights build legends.

Nicht jeder wird verstehen, was Hussling ist.

Es sind die Stunden, in denen die meisten schlafen und du weiter dein Ding machst. Noch ein Projekt. Noch eine Idee. Noch ein Move. Musik läuft im Hintergrund, die Stadt wird langsamer und dein Kopf läuft auf Hochtouren.
Late Night Hussla ist genau aus dieser Stimmung entstanden.
Es ist nicht nur ein Glasfilter. Es ist Teil der Hussler-Kultur – Menschen, die wissen, dass Lifestyle jeden Tag aufgebaut wird, nicht nur, wenn jemand zusieht.

Built Different.
Im Inneren findest du 9 spiralförmig angeordnete Löcher, die den Weg des Rauchs durch das Glas verlängern. So hat der Rauch mehr Zeit zum Abkühlen und das Ganze sorgt für ein weicheres, angenehmeres Erlebnis.
Es ist ein Detail, das man auf den ersten Blick nicht sieht.
Aber genau aus Details besteht Hussling.
Genauso wie man die Stunden nicht sieht, die man in den eigenen Weg steckt.

Made to Last.
Gefertigt aus hochwertigem Borosilikatglas, beständig gegen hohe Temperaturen und den täglichen Gebrauch.
Mattes Schwarz mit dem SlimeGlass-Logo wirkt minimalistisch, sagt aber alles.
Ohne unnötigen Flex.
Denn echter Stil muss nicht schreien.

Spezifikation
Marke: SlimeGlass
Modell: Late Night Hussla
Material: Borosilikatglas
Farbe: Black
Länge: 35 mm
Durchmesser: 12 mm
Innen: 9 spiralförmige Kühllöcher`,
  },
  "fried-g": {
    pl: `Fried G Red Glass Filter 12 mm | 35 mm
Stay Fried. Stay Focused.

Nie wszystko musi być głośne, żeby robiło wrażenie.
Fried G to czerwony szklany filtr od SlimeGlass, inspirowany nocnymi sesjami, dobrym vibem i ludźmi, którzy zawsze idą własną drogą. Intensywna czerwień symbolizuje energię, charakter i pewność siebie – bo styl to coś więcej niż wygląd.
To nie jest zwykły tip.
To kolejny element kultury SG Fam.

Built for the Culture.
Wewnątrz filtra znajduje się 9 przelotowych otworów ułożonych w spiralę, które wydłużają drogę przepływu przez szkło. Dzięki temu przepływ jest bardziej płynny, a szkło zachowuje swoje właściwości podczas wielokrotnego użytkowania.
Bo w SlimeGlass wierzymy, że to właśnie detale robią największą różnicę.
Tak samo jest z budowaniem własnej historii.
Każdy ma 24 godziny.
Nie każdy wykorzystuje je tak samo.

Red Means Energy.
Intensywna czerwień nie pojawiła się tutaj przypadkiem.
To kolor ludzi, którzy mają odwagę być sobą. Którzy nie boją się wyróżniać i tworzyć własnego stylu.
Nie kopiujesz.
Tworzysz.
Nie podążasz za trendami.
Tworzysz własny kierunek.

Made to Last.
Fried G został wykonany z wysokiej jakości Borosilicate Glass – szkła odpornego na wysokie temperatury i stworzonego do wielokrotnego użytkowania.
Solidna konstrukcja, charakterystyczny czerwony kolor oraz logo SlimeGlass sprawiają, że ten filtr wygląda równie dobrze, jak został wykonany.
Minimalizm.
Jakość.
Kultura.

Specyfikacja
Marka: SlimeGlass
Model: Fried G
Materiał: Borosilicate Glass
Kolor: Czerwony
Długość: 35 mm
Średnica: 12 mm
System: 9 spiralnie rozmieszczonych otworów`,
    en: `Fried G Red Glass Filter 12 mm | 35 mm
Stay Fried. Stay Focused.

Not everything has to be loud to make an impression.
Fried G is a red glass filter from SlimeGlass, inspired by late-night sessions, good vibes and people who always go their own way. The intense red symbolises energy, character and confidence – because style is more than just looks.
This isn't your average tip.
It's another piece of the SG Fam culture.

Built for the Culture.
Inside the filter are 9 through-holes arranged in a spiral, extending the flow path through the glass. This makes the draw smoother, while the glass keeps its properties through repeated use.
Because at SlimeGlass we believe it's the details that make the biggest difference.
Same as with building your own story.
Everyone has 24 hours.
Not everyone uses them the same way.

Red Means Energy.
The intense red didn't end up here by accident.
It's the colour of people who have the courage to be themselves. Who aren't afraid to stand out and create their own style.
You don't copy.
You create.
You don't follow trends.
You set your own direction.

Made to Last.
Fried G is made from high-quality Borosilicate Glass – glass resistant to high temperatures and built for repeated use.
Solid construction, the signature red colour and the SlimeGlass logo make this filter look as good as it's made.
Minimalism.
Quality.
Culture.

Specification
Brand: SlimeGlass
Model: Fried G
Material: Borosilicate Glass
Colour: Red
Length: 35 mm
Diameter: 12 mm
System: 9 spiral-set holes`,
    cs: `Fried G Red Glass Filter 12 mm | 35 mm
Stay Fried. Stay Focused.

Ne všechno musí být hlučné, aby to udělalo dojem.
Fried G je červený skleněný filtr od SlimeGlass, inspirovaný nočními sessions, dobrým vibem a lidmi, kteří jdou vždycky vlastní cestou. Intenzivní červená symbolizuje energii, charakter a sebevědomí – protože styl je víc než jen vzhled.
Tohle není obyčejný tip.
Je to další součást kultury SG Fam.

Built for the Culture.
Uvnitř filtru je 9 průchozích otvorů uspořádaných do spirály, které prodlužují cestu průtoku sklem. Tah je díky tomu plynulejší a sklo si zachovává své vlastnosti i při opakovaném používání.
Protože v SlimeGlass věříme, že právě detaily dělají největší rozdíl.
Stejně jako u budování vlastního příběhu.
Každý má 24 hodin.
Ne každý je využívá stejně.

Red Means Energy.
Intenzivní červená se tu neobjevila náhodou.
Je to barva lidí, kteří mají odvahu být sami sebou. Kteří se nebojí vyčnívat a tvořit vlastní styl.
Nekopíruješ.
Tvoříš.
Nejdeš za trendy.
Určuješ si vlastní směr.

Made to Last.
Fried G je vyrobený z kvalitního borosilikátového skla – skla odolného vůči vysokým teplotám a stvořeného pro opakované používání.
Solidní konstrukce, charakteristická červená barva a logo SlimeGlass dělají z tohohle filtru kousek, který vypadá stejně dobře, jako je vyrobený.
Minimalismus.
Kvalita.
Kultura.

Specifikace
Značka: SlimeGlass
Model: Fried G
Materiál: Borosilikátové sklo
Barva: Červená
Délka: 35 mm
Průměr: 12 mm
Systém: 9 spirálovitě rozmístěných otvorů`,
    de: `Fried G Red Glass Filter 12 mm | 35 mm
Stay Fried. Stay Focused.

Nicht alles muss laut sein, um Eindruck zu machen.
Fried G ist ein roter Glasfilter von SlimeGlass, inspiriert von nächtlichen Sessions, gutem Vibe und Menschen, die immer ihren eigenen Weg gehen. Das intensive Rot steht für Energie, Charakter und Selbstbewusstsein – denn Stil ist mehr als nur Aussehen.
Das ist kein gewöhnlicher Tip.
Es ist ein weiteres Stück der SG-Fam-Kultur.

Built for the Culture.
Im Inneren des Filters befinden sich 9 durchgehende, spiralförmig angeordnete Löcher, die den Strömungsweg durch das Glas verlängern. Dadurch wird der Zug weicher, während das Glas seine Eigenschaften auch bei wiederholtem Gebrauch behält.
Denn bei SlimeGlass glauben wir, dass genau die Details den größten Unterschied machen.
Genauso wie beim Aufbau deiner eigenen Geschichte.
Jeder hat 24 Stunden.
Nicht jeder nutzt sie auf die gleiche Weise.

Red Means Energy.
Das intensive Rot ist nicht zufällig hier gelandet.
Es ist die Farbe der Menschen, die den Mut haben, sie selbst zu sein. Die keine Angst haben, aufzufallen und ihren eigenen Stil zu schaffen.
Du kopierst nicht.
Du erschaffst.
Du folgst keinen Trends.
Du bestimmst deine eigene Richtung.

Made to Last.
Fried G ist aus hochwertigem Borosilikatglas gefertigt – einem Glas, das hohen Temperaturen standhält und für den wiederholten Gebrauch gemacht ist.
Die solide Konstruktion, die markante rote Farbe und das SlimeGlass-Logo lassen diesen Filter so gut aussehen, wie er gemacht ist.
Minimalismus.
Qualität.
Kultur.

Spezifikation
Marke: SlimeGlass
Modell: Fried G
Material: Borosilikatglas
Farbe: Rot
Länge: 35 mm
Durchmesser: 12 mm
System: 9 spiralförmig angeordnete Löcher`,
  },
  "slimeski": {
    pl: `Slimeski Green Glass Filter 10 mm | 35 mm
Stay Fresh. Stay Different.

Najlepszy styl nie potrzebuje przedstawiania.
Slimeski to zielony szklany filtr od SlimeGlass, stworzony dla tych, którzy cenią własny charakter i świadomie wybierają jakość. Głęboka zieleń symbolizuje świeżość, rozwój i autentyczność – wartości, które od początku są częścią SlimeGlass.
To nie jest zwykły tip.
To kolejny element kultury SG Fam.

Built for the Culture.
Wewnątrz filtra znajduje się 9 przelotowych otworów ułożonych w spiralę, które wydłużają drogę przepływu przez szkło. Dzięki temu przepływ jest bardziej płynny, a szkło zachowuje swoje właściwości podczas wielokrotnego użytkowania.
Bo w SlimeGlass wierzymy, że największą różnicę tworzą detale.
To właśnie one budują jakość.
To właśnie one budują styl.
Każdy detal ma znaczenie.

Green Means Growth.
Zieleń to kolor świeżego spojrzenia, kreatywności i nieustannego rozwoju.
To wybór ludzi, którzy nie boją się iść własną drogą i tworzyć coś po swojemu.
Nie musisz być głośny.
Wystarczy, że jesteś prawdziwy.
Nie podążasz za trendami.
Tworzysz własny styl.

Made to Last.
Slimeski został wykonany z wysokiej jakości Borosilicate Glass – szkła odpornego na wysokie temperatury i stworzonego do wielokrotnego użytkowania.
Solidna konstrukcja, charakterystyczny zielony kolor oraz logo SlimeGlass sprawiają, że ten filtr wygląda równie dobrze, jak został wykonany.
Minimalizm.
Jakość.
Kultura.

Specyfikacja
Marka: SlimeGlass
Model: Slimeski
Materiał: Borosilicate Glass
Kolor: Zielony
Długość: 35 mm
Średnica: 10 mm
System: 9 spiralnie rozmieszczonych otworów`,
    en: `Slimeski Green Glass Filter 10 mm | 35 mm
Stay Fresh. Stay Different.

The best style needs no introduction.
Slimeski is a green glass filter from SlimeGlass, made for those who value their own character and consciously choose quality. The deep green symbolises freshness, growth and authenticity – values that have been part of SlimeGlass from the start.
This isn't your average tip.
It's another piece of the SG Fam culture.

Built for the Culture.
Inside the filter are 9 through-holes arranged in a spiral, extending the flow path through the glass. This makes the draw smoother, while the glass keeps its properties through repeated use.
Because at SlimeGlass we believe the biggest difference is made by the details.
They're what build quality.
They're what build style.
Every detail matters.

Green Means Growth.
Green is the colour of a fresh perspective, creativity and constant growth.
It's the choice of people who aren't afraid to go their own way and create things on their own terms.
You don't have to be loud.
It's enough to be real.
You don't follow trends.
You create your own style.

Made to Last.
Slimeski is made from high-quality Borosilicate Glass – glass resistant to high temperatures and built for repeated use.
Solid construction, the signature green colour and the SlimeGlass logo make this filter look as good as it's made.
Minimalism.
Quality.
Culture.

Specification
Brand: SlimeGlass
Model: Slimeski
Material: Borosilicate Glass
Colour: Green
Length: 35 mm
Diameter: 10 mm
System: 9 spiral-set holes`,
    cs: `Slimeski Green Glass Filter 10 mm | 35 mm
Stay Fresh. Stay Different.

Nejlepší styl nepotřebuje představení.
Slimeski je zelený skleněný filtr od SlimeGlass, stvořený pro ty, kteří si cení vlastního charakteru a vědomě volí kvalitu. Sytá zeleň symbolizuje svěžest, růst a autenticitu – hodnoty, které jsou od začátku součástí SlimeGlass.
Tohle není obyčejný tip.
Je to další součást kultury SG Fam.

Built for the Culture.
Uvnitř filtru je 9 průchozích otvorů uspořádaných do spirály, které prodlužují cestu průtoku sklem. Tah je díky tomu plynulejší a sklo si zachovává své vlastnosti i při opakovaném používání.
Protože v SlimeGlass věříme, že největší rozdíl dělají detaily.
Právě ony budují kvalitu.
Právě ony budují styl.
Na každém detailu záleží.

Green Means Growth.
Zelená je barvou svěžího pohledu, kreativity a neustálého růstu.
Je to volba lidí, kteří se nebojí jít vlastní cestou a tvořit něco po svém.
Nemusíš být hlučný.
Stačí být opravdový.
Nejdeš za trendy.
Tvoříš vlastní styl.

Made to Last.
Slimeski je vyrobený z kvalitního borosilikátového skla – skla odolného vůči vysokým teplotám a stvořeného pro opakované používání.
Solidní konstrukce, charakteristická zelená barva a logo SlimeGlass dělají z tohohle filtru kousek, který vypadá stejně dobře, jako je vyrobený.
Minimalismus.
Kvalita.
Kultura.

Specifikace
Značka: SlimeGlass
Model: Slimeski
Materiál: Borosilikátové sklo
Barva: Zelená
Délka: 35 mm
Průměr: 10 mm
Systém: 9 spirálovitě rozmístěných otvorů`,
    de: `Slimeski Green Glass Filter 10 mm | 35 mm
Stay Fresh. Stay Different.

Der beste Stil braucht keine Vorstellung.
Slimeski ist ein grüner Glasfilter von SlimeGlass, gemacht für alle, die ihren eigenen Charakter schätzen und bewusst auf Qualität setzen. Das tiefe Grün steht für Frische, Wachstum und Authentizität – Werte, die von Anfang an Teil von SlimeGlass sind.
Das ist kein gewöhnlicher Tip.
Es ist ein weiteres Stück der SG-Fam-Kultur.

Built for the Culture.
Im Inneren des Filters befinden sich 9 durchgehende, spiralförmig angeordnete Löcher, die den Strömungsweg durch das Glas verlängern. Dadurch wird der Zug weicher, während das Glas seine Eigenschaften auch bei wiederholtem Gebrauch behält.
Denn bei SlimeGlass glauben wir, dass den größten Unterschied die Details machen.
Sie sind es, die Qualität schaffen.
Sie sind es, die Stil schaffen.
Jedes Detail zählt.

Green Means Growth.
Grün ist die Farbe eines frischen Blicks, der Kreativität und des ständigen Wachstums.
Es ist die Wahl der Menschen, die keine Angst haben, ihren eigenen Weg zu gehen und Dinge auf ihre Art zu schaffen.
Du musst nicht laut sein.
Es reicht, echt zu sein.
Du folgst keinen Trends.
Du erschaffst deinen eigenen Stil.

Made to Last.
Slimeski ist aus hochwertigem Borosilikatglas gefertigt – einem Glas, das hohen Temperaturen standhält und für den wiederholten Gebrauch gemacht ist.
Die solide Konstruktion, die markante grüne Farbe und das SlimeGlass-Logo lassen diesen Filter so gut aussehen, wie er gemacht ist.
Minimalismus.
Qualität.
Kultur.

Spezifikation
Marke: SlimeGlass
Modell: Slimeski
Material: Borosilikatglas
Farbe: Grün
Länge: 35 mm
Durchmesser: 10 mm
System: 9 spiralförmig angeordnete Löcher`,
  },
  "heavy-dreamer": {
    pl: `Heavy Dreamer Yellow Glass Filter 10 mm | 35 mm
Dream Big. Stay Heavy.

Każda wielka historia zaczyna się od jednego pomysłu.
Heavy Dreamer to żółty szklany filtr od SlimeGlass, stworzony dla ludzi, którzy nie boją się marzyć i zamieniać wizji w rzeczywistość. Intensywny żółty kolor symbolizuje kreatywność, optymizm i odwagę do tworzenia własnej drogi.
To nie jest zwykły tip.
To kolejny element kultury SG Fam.

Built for the Culture.
Wewnątrz filtra znajduje się 9 przelotowych otworów ułożonych w spiralę, które wydłużają drogę przepływu przez szkło. Dzięki temu przepływ jest bardziej płynny, a szkło zachowuje swoje właściwości podczas wielokrotnego użytkowania.
Bo w SlimeGlass wierzymy, że największą różnicę tworzą detale.
To właśnie one budują jakość.
To właśnie one budują charakter.
Każdy detal ma znaczenie.

Yellow Means Vision.
Żółty to kolor ludzi, którzy patrzą dalej niż inni.
To energia nowych pomysłów.
To kreatywność bez ograniczeń.
To odwaga, żeby zacząć, zanim wszyscy uwierzą, że to możliwe.
Nie czekasz na idealny moment.
Tworzysz go sam.

Made to Last.
Heavy Dreamer został wykonany z wysokiej jakości Borosilicate Glass – szkła odpornego na wysokie temperatury i stworzonego do wielokrotnego użytkowania.
Solidna konstrukcja, charakterystyczny żółty kolor oraz logo SlimeGlass sprawiają, że ten filtr wygląda równie dobrze, jak został wykonany.
Minimalizm.
Jakość.
Kultura.

Specyfikacja
Marka: SlimeGlass
Model: Heavy Dreamer
Materiał: Borosilicate Glass
Kolor: Żółty
Długość: 35 mm
Średnica: 10 mm
System: 9 spiralnie rozmieszczonych otworów`,
    en: `Heavy Dreamer Yellow Glass Filter 10 mm | 35 mm
Dream Big. Stay Heavy.

Every great story starts with a single idea.
Heavy Dreamer is a yellow glass filter from SlimeGlass, made for people who aren't afraid to dream and turn vision into reality. The intense yellow symbolises creativity, optimism and the courage to build your own path.
This isn't your average tip.
It's another piece of the SG Fam culture.

Built for the Culture.
Inside the filter are 9 through-holes arranged in a spiral, extending the flow path through the glass. This makes the draw smoother, while the glass keeps its properties through repeated use.
Because at SlimeGlass we believe the biggest difference is made by the details.
They're what build quality.
They're what build character.
Every detail matters.

Yellow Means Vision.
Yellow is the colour of people who look further than others.
It's the energy of new ideas.
It's creativity without limits.
It's the courage to start before everyone believes it's possible.
You don't wait for the perfect moment.
You create it yourself.

Made to Last.
Heavy Dreamer is made from high-quality Borosilicate Glass – glass resistant to high temperatures and built for repeated use.
Solid construction, the signature yellow colour and the SlimeGlass logo make this filter look as good as it's made.
Minimalism.
Quality.
Culture.

Specification
Brand: SlimeGlass
Model: Heavy Dreamer
Material: Borosilicate Glass
Colour: Yellow
Length: 35 mm
Diameter: 10 mm
System: 9 spiral-set holes`,
    cs: `Heavy Dreamer Yellow Glass Filter 10 mm | 35 mm
Dream Big. Stay Heavy.

Každý velký příběh začíná jedním nápadem.
Heavy Dreamer je žlutý skleněný filtr od SlimeGlass, stvořený pro lidi, kteří se nebojí snít a měnit vize ve skutečnost. Intenzivní žlutá barva symbolizuje kreativitu, optimismus a odvahu tvořit vlastní cestu.
Tohle není obyčejný tip.
Je to další součást kultury SG Fam.

Built for the Culture.
Uvnitř filtru je 9 průchozích otvorů uspořádaných do spirály, které prodlužují cestu průtoku sklem. Tah je díky tomu plynulejší a sklo si zachovává své vlastnosti i při opakovaném používání.
Protože v SlimeGlass věříme, že největší rozdíl dělají detaily.
Právě ony budují kvalitu.
Právě ony budují charakter.
Na každém detailu záleží.

Yellow Means Vision.
Žlutá je barvou lidí, kteří vidí dál než ostatní.
Je to energie nových nápadů.
Je to kreativita bez hranic.
Je to odvaha začít dřív, než všichni uvěří, že je to možné.
Nečekáš na ideální okamžik.
Vytváříš si ho sám.

Made to Last.
Heavy Dreamer je vyrobený z kvalitního borosilikátového skla – skla odolného vůči vysokým teplotám a stvořeného pro opakované používání.
Solidní konstrukce, charakteristická žlutá barva a logo SlimeGlass dělají z tohohle filtru kousek, který vypadá stejně dobře, jako je vyrobený.
Minimalismus.
Kvalita.
Kultura.

Specifikace
Značka: SlimeGlass
Model: Heavy Dreamer
Materiál: Borosilikátové sklo
Barva: Žlutá
Délka: 35 mm
Průměr: 10 mm
Systém: 9 spirálovitě rozmístěných otvorů`,
    de: `Heavy Dreamer Yellow Glass Filter 10 mm | 35 mm
Dream Big. Stay Heavy.

Jede große Geschichte beginnt mit einer einzigen Idee.
Heavy Dreamer ist ein gelber Glasfilter von SlimeGlass, gemacht für Menschen, die keine Angst haben zu träumen und Visionen in Realität zu verwandeln. Das intensive Gelb steht für Kreativität, Optimismus und den Mut, den eigenen Weg zu gehen.
Das ist kein gewöhnlicher Tip.
Es ist ein weiteres Stück der SG-Fam-Kultur.

Built for the Culture.
Im Inneren des Filters befinden sich 9 durchgehende, spiralförmig angeordnete Löcher, die den Strömungsweg durch das Glas verlängern. Dadurch wird der Zug weicher, während das Glas seine Eigenschaften auch bei wiederholtem Gebrauch behält.
Denn bei SlimeGlass glauben wir, dass den größten Unterschied die Details machen.
Sie sind es, die Qualität schaffen.
Sie sind es, die Charakter schaffen.
Jedes Detail zählt.

Yellow Means Vision.
Gelb ist die Farbe der Menschen, die weiter blicken als andere.
Es ist die Energie neuer Ideen.
Es ist Kreativität ohne Grenzen.
Es ist der Mut anzufangen, bevor alle glauben, dass es möglich ist.
Du wartest nicht auf den perfekten Moment.
Du erschaffst ihn selbst.

Made to Last.
Heavy Dreamer ist aus hochwertigem Borosilikatglas gefertigt – einem Glas, das hohen Temperaturen standhält und für den wiederholten Gebrauch gemacht ist.
Die solide Konstruktion, die markante gelbe Farbe und das SlimeGlass-Logo lassen diesen Filter so gut aussehen, wie er gemacht ist.
Minimalismus.
Qualität.
Kultur.

Spezifikation
Marke: SlimeGlass
Modell: Heavy Dreamer
Material: Borosilikatglas
Farbe: Gelb
Länge: 35 mm
Durchmesser: 10 mm
System: 9 spiralförmig angeordnete Löcher`,
  },
};

export function getProductDescription(slug, lang, fallback = "") {
  const entry = PRODUCT_DESCRIPTIONS[slug];
  if (!entry) return fallback;
  return entry[lang] || entry.en || fallback;
}

// Per-product width shown in the product spec grid (keyed by Shopify handle).
export const PRODUCT_WIDTHS = {
  "late-night-hussla": "12mm",
  "fried-g": "12mm",
  "slimeski": "10mm",
  "heavy-dreamer": "10mm",
};
